import React from 'react'
import { useDashboard } from '../DashboardContext'

export function TrialImportPrompt() {
  const { currentSubscription, contacts, contactsLoading, setActivePage } = useDashboard()
  const [dismissed, setDismissed] = React.useState(false)

  if (dismissed || contactsLoading) return null

  const isTrialing = currentSubscription?.subscription?.status === 'TRIALING'
  if (!isTrialing) return null
  if (contacts.length > 0) return null

  return (
    <div className="px-7 pt-4">
      <div
        role="alert"
        className="relative flex items-start justify-between gap-4 flex-wrap rounded-2xl px-5 py-4 bg-[#e05a2b]/[0.04] border border-[#e05a2b]/15 shadow-[0_1px_3px_rgba(0,0,0,0.03)] overflow-hidden"
      >
        {/* Subtle left accent */}
        <span className="absolute left-0 top-4 bottom-4 w-[3px] rounded-full bg-[#e05a2b]" />

        <div className="flex-1 min-w-[240px] pl-3">
          <div
            className="text-[13px] font-semibold text-gray-900 mb-1 tracking-tight"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Your trial is running — import contacts to put it to work
          </div>
          <div className="text-[12px] text-gray-600 leading-relaxed">
            Nudge sends re-engagement emails to customers who haven't visited recently.
            Import contacts <strong className="font-semibold text-gray-900">with past visit dates</strong> and the AI starts
            sending on day&nbsp;1.
          </div>
        </div>

        <div className="flex items-center gap-1.5 shrink-0">
          <button
            type="button"
            onClick={() => setActivePage('contacts')}
            className="inline-flex items-center gap-1.5 px-4 py-[7px] rounded-full text-[12.5px] font-bold text-white bg-[#e05a2b] border border-black shadow-[2px_2px_0_#111] transition-all duration-150 whitespace-nowrap
              hover:bg-[#c44a1e] hover:-translate-x-[1px] hover:-translate-y-[1px] hover:shadow-[3px_3px_0_#111]
              active:translate-x-[1px] active:translate-y-[1px] active:shadow-[1px_1px_0_#111]"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Import contacts
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="grid place-items-center w-7 h-7 rounded-full text-gray-400 hover:text-gray-700 hover:bg-black/[0.04] transition-colors"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
